import React, { Fragment } from 'react';
import { isEmpty } from 'lodash';
import { IconClock, IconStar } from '@tabler/icons';
import {
  Avatar,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@mui/material';

export default function FindClinicFaveRecentTable({ label, data, onClick }) {
  return (
    <Grid container direction="column">
      <Grid item>
        <Typography gutterBottom variant="h4">
          {label}:
        </Typography>
        <List>
          {data.rows.map(provider => {
            return (
              <Fragment key={provider.id}>
                <ListItem
                  key={provider.id}
                  onClick={() => {
                    onClick({ row: provider });
                  }}
                  sx={{
                    '&:hover': {
                      backgroundColor: '#6dd2bf',
                      color: 'white',
                      '& .MuiListItemIcon-root': {
                        color: 'white',
                      },
                    },
                  }}
                >
                  <ListItemAvatar>
                    <Avatar style={{ width: 24, height: 24 }} sx={{ width: 24, height: 24 }}>
                      {label === 'Favorites' ? (
                        <IconStar
                          style={{ width: 16, height: 16 }}
                          sx={{ width: 16, height: 16 }}
                        />
                      ) : (
                        <IconClock
                          style={{ width: 16, height: 16 }}
                          sx={{ width: 16, height: 16 }}
                        />
                      )}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={provider.display_name + ' - ' + provider.clinic.name} />
                </ListItem>
                <Divider />
              </Fragment>
            );
          })}
          {isEmpty(data.rows) && (
            <ListItem key={'empty'}>
              <ListItemText primary={'Empty ' + label} />
            </ListItem>
          )}
        </List>
      </Grid>
    </Grid>
  );
}
